export default __webpack_public_path__ + "static/media/ic_submission.d66ac2de.svg";